import React from 'react';

import './Authentication.scss';

import SignUpForm from '../../components/SignUpForm/SignUpForm';

import SignInForm from '../../components/SignInForm/SignInForm';

const Authentication = () => {
  // const logGoogleRedirectUser = async () => {
  //   const { user } = await signInWithGoogleRedirect();
  //   console.log('logGoogleRedirectUser', user);
  // };

  return (
    <div className="authentication-container">
      <SignInForm />
      <SignUpForm />
    </div>
  );
};

// into App
export default Authentication;
